var posts = [];
var post = {
	folder: "",
	id : "",
	init: function(){
		post.nav();
		post.checkHash();
		window.addEventListener("hashchange", function(){
			post.checkHash();
		});
	},
	nav: function(){
		$("#block_grid li a").off().on("click", function(){
			var id = $(this).attr("data-url");
			location.hash = "/post/" + id;
		});
		$("#close_bg").off().on("click", function(){
			location.hash = "/";
		});
		$("a.btn_close_modal").off().on("click", function(){
			location.hash = "/";
		});
		$("a.btn_close_modal_btm").off().on("click", function(){
			location.hash = "/";
		});
	},
	changePost: function(){
		var p = posts[post.id];
		var title = p.title;
		var client = p.client;
		$("#modal h3").html(title);
		$("#modal p.client").html(client);
		$("#modal p.about").html(p.about);
		$("#modal p.ja").html(p.ja);
		$("#modal p.en").html(p.en);
		
		var imgArry = [];
		var col1 	= p.col1image;
		var col1HTML = '';
		var col2 	= p.col2image;
		var col2HTML = '';
		//col1
		for(var i = 0; i < col1.length; i++){
			var img = "/assets/images/works/" + col1[i];
			imgArry.push(img);
			col1HTML += '<li><img src="' + img + '"></li>';
		}
		//col2
		for(var j = 0; j < col2.length; j++){
			var img = "/assets/images/works/" + col2[j];
			imgArry.push(img);
			col2HTML += '<li><img src="' + img + '"></li>';
		}
		var credit 		= p.credit;
		var creditHTML 	= '';
		for(var k = 0; k < credit.length; k++){
			var c = credit[k];
			creditHTML += '<li>' + c + '</li>';
		}
		$("#modal .credit ul").html(creditHTML);
		$("#img_col1 ul").html(col1HTML);
		$("#img_col2 ul").html(col2HTML);

		if(p.url != ""){
			var linkURL = '<a href="' + p.url + '" target="_blank">' + p.url + '</a>'
			$(".site_link dt").html(p.site_title);
			$(".site_link dd").html(linkURL);
			$(".site_link").css("display", "block");
		}else{
			$(".site_link").css("display", "none");
		}
		this.load(imgArry);
	},
	load: function(imgs){
		if(isFirstTime){
			isFirstTime = false;
			post.open();
		}else{
			preload.reset();
			$("#loading").removeClass();
			$("#loading").fadeIn(200, function(){
				preload.startLoad(imgs.length,imgs).done(function(){
					setTimeout(function(){
						post.open();
						$("#loading").fadeOut(200, function(){
							$("#loading").removeClass();
						});
						$(".modal_inner").animate({
							scrollTop : "0px"
						},{
							"duration" 	: 100
						});
					},400);
				});
			});
		}
		
	},
	open: function(){
		var $body = $("body");
		if(!$body.hasClass("modal")){
			$body.addClass("modal");
			setTimeout(function(){
				$body.addClass("show_modal");
				$(".modal_inner").off().on("scroll", function(){
					post.scrl();
				});
			},50);
		}
	},
	close: function(){
		var $body = $("body"),
			header = $("header"),
			$close = $("a.btn_close_modal");
		if(header.hasClass("small")){
			header.removeClass("small");
		}
		
		if($body.hasClass("modal")){
			$body.removeClass("show_modal");
			setTimeout(function(){
				$body.removeClass("modal");
				if($close.hasClass("hide")){
					$close.removeClass("hide");
				}
			},600);
		}
	},
	checkHash: function(){
		var hash 	= location.hash;
		var hashAry = hash.split("/");
		var hashLen = hashAry.length;
		var lastHash = hashAry[hashLen - 1];
		post.folder = hashAry[hashLen - 2];
		post.id 	= getNum(lastHash);
		//console.log(post.folder, post.id, hashLen)

		if(lastHash === "" || lastHash === "#" || hash === "#/"){
			post.close();
		}else{
			if(post.folder === "post"){
				post.changePost();
			}
		}
	},
	scrl: function(){
		var topD = $(".modal_inner").scrollTop(),
			btmD = topD + $(window).height(),
			header = $("header"),
			$close = $("a.btn_close_modal"),
			$closePos = $(".content").outerHeight();
		if(topD >= 100){
			if(!header.hasClass("small")){
				header.addClass("small");
			}
		}else{
			if(header.hasClass("small")){
				header.removeClass("small");
			}
		}
		if(btmD >= $closePos){
			if(!$close.hasClass("hide")){
				$close.addClass("hide");
			}
		}else{
			if($close.hasClass("hide")){
				$close.removeClass("hide");
			}
		}
	}
}